module.exports = __webpack_public_path__ + "static/media/reset-password.855c313a.png";